import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import PermissionRoute from './PermissionRoute';

const Routes = () => {

	return (
		<RouterRoutes>
			{/* Public routes first - check-in page is default at "/" */}
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path || route.key} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
			</Route>
			{/* Protected routes */}
			<Route element={<ProtectedRoute />}>
				{protectedRoutes.map((route, index) => {
					// If route has permission requirement, wrap with PermissionRoute
					const RouteComponent = route.permission 
						? (props) => (
							<PermissionRoute 
								component={route.component}
								resource={route.permission.resource}
								action={route.permission.action}
								{...props}
							/>
						)
						: route.component;

					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={RouteComponent}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes
